import { useQuery} from '@tanstack/react-query';
import { useItemsApi } from './useItemsApi';
import qs from 'qs';
import type { UpcomingBiddingListResponse} from '../types';

// 全権限対応のHook
export const useBiddingItemsGetAllRoleItemListQuery = (filters: any, loginId: string, options?: { enabled?: boolean }) => {
  const { biddingInfoGetList } = useItemsApi();

  return useQuery<UpcomingBiddingListResponse, Error>({
    // キーはシンプルに
    queryKey: ['listingSchedule', 'all', filters, loginId],
    
    queryFn: async () => {
      // フィルタ整形
      const cleanFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v != null && v !== '')
      );
      const queryString = qs.stringify(cleanFilters, { arrayFormat: 'repeat' });
      // AdminでもSellerでもBuyerでも、サブアイテム付きのデータが取れる
      return await biddingInfoGetList(queryString);
    },
    // 外部から options.enabled が渡されたらそれを使い、なければ loginId の有無で判定する
    enabled: options?.enabled !== undefined ? options.enabled : !!loginId,
  });
};

export const useBiddingItemsGetUpcomingListQuery = (
  filters: any, 
  loginId: string, 
  options?: { enabled?: boolean }
) => {
  const { biddingInfoGetUpcomingList } = useItemsApi();

  return useQuery<UpcomingBiddingListResponse, Error>({
    queryKey: ['listingSchedule', 'upcoming', filters, loginId],
    queryFn: async () => {
      const cleanFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v != null && v !== '')
      );
      const queryString = qs.stringify(cleanFilters, { arrayFormat: 'repeat' });
      return await biddingInfoGetUpcomingList(queryString);
    },
    // ここが重要：loginIdがあり、かつ外部から無効化されていなければ実行
    enabled: options?.enabled !== undefined ? options.enabled : !!loginId,
    ...options,
  });
};